import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { AUTH_CLIENT_TOKEN, AuthClientProvider, MODAL_TOKEN, ModalProvider, PresentModalComponent } from '@core';
import { getFirebaseAuthErrorMessage } from '../../application/utils';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { sendPasswordResetEmail } from '@angular/fire/auth';
import { from, take } from 'rxjs';

@Component({
  selector: 'lib-reset-password',
  templateUrl: './reset-password.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [FormsModule, ReactiveFormsModule]
})
export class ResetPasswordComponent {
  @Output() email: EventEmitter<string> = new EventEmitter<string>();

  private readonly modalProvider: ModalProvider = inject(MODAL_TOKEN);
  private readonly authClientProvider: AuthClientProvider = inject(AUTH_CLIENT_TOKEN);

  readonly emailForm: FormGroup = new FormGroup({
    email: new FormControl('', [Validators.required])
  });

  closeModal(): void {
    this.modalProvider.dismissAllStoredModals();
  }

  resetPassword(): void {
    from(sendPasswordResetEmail(this.authClientProvider.authClient, this.emailForm.get('email')?.value))
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.modalProvider.showModal$({
            component: PresentModalComponent,
            componentProps: {
              header: 'Przypomnij hasło',
              message: 'Sukces. Jeśli posiadasz u nas konto link zostanie wyslany na Twój adres e-mail.',
              btnTxt: 'Zamknij'
            },
            cssClass: 'present-modal'
          });
        },
        error: (err: unknown) => {
          const { header, message } = getFirebaseAuthErrorMessage(err, 'Przypomnij hasło');
          this.modalProvider.showModal$({
            component: PresentModalComponent,
            componentProps: {
              header,
              message,
              btnTxt: 'Zamknij'
            },
            cssClass: 'present-modal'
          });
        }
      });
  }
}
